import React, { Component } from 'react';

export const wrapper = options => WrappedComponent => {
  const apiKey = options.apiKey;
  const libraries = options.libraries || ['places'];

  class Wrapper extends Component {
    state = {
      loaded: false,
      Maps: null,
    };

    // componentDidMount() {}

    componentDidMount() {
      if (typeof window !== 'undefined') {
        const { load, urlSettings, release } = require('../lib/google-promise');
        urlSettings.key = apiKey;
        load()
          .then(Maps => {
            console.log('Google Maps Loaded');
            return this.setState({
              loaded: true,
              Maps: Maps,
            });
          })
          .catch(err => {
            console.log(err);
            throw err;
          });
      }
    }

    componentWillUnmount() {
      // release()
      //   .then(() => console.log('No google maps api around'))
      //   .catch(err => {
      //     console.log(err);
      //     throw err;
      //   });
    }

    render() {
      const props = Object.assign({}, this.props, {
        loaded: this.state.loaded,
        Maps: this.state.Maps,
      });
      return (
        this.state.loaded && this.state.Maps && <WrappedComponent {...props} />
      );
    }
  }

  return Wrapper;
};

export default wrapper;



// WEBPACK FOOTER //
// ./src/components/tour/map/utils/GoogleApiComponent.js